import { t as g } from "./observe-slot-text-DWmBsDhw.js";
const e = Symbol("slotContentIsPresent");
function b(l, r) {
  var i, c;
  const o = Array.isArray(r) ? r : [r];
  class h extends (c = l, i = e, c) {
    constructor(...t) {
      super(t), this[i] = /* @__PURE__ */ new Map(), this.managePresenceObservedSlot = () => {
        let n = !1;
        o.forEach((s) => {
          const a = !!this.querySelector(`:scope > ${s}`), d = this[e].get(s) || !1;
          n = n || d !== a, this[e].set(s, !!this.querySelector(`:scope > ${s}`));
        }), n && this.updateComplete.then(() => {
          this.requestUpdate();
        });
      }, new g(this, { config: { childList: !0, subtree: !0 }, callback: () => {
        this.managePresenceObservedSlot();
      } }), this.managePresenceObservedSlot();
    }
    get slotContentIsPresent() {
      if (o.length === 1) return this[e].get(o[0]) || !1;
      throw new Error("Multiple selectors provided to `ObserveSlotPresence` use `getSlotContentPresence(selector: string)` instead.");
    }
    getSlotContentPresence(t) {
      if (this[e].has(t)) return this[e].get(t) || !1;
      throw new Error(`The provided selector \`${t}\` is not being observed.`);
    }
  }
  return h;
}
export {
  b as O
};
//# sourceMappingURL=observe-slot-presence-BhCYOJih.js.map
